
import moment from 'moment';


const getDaysDiffrence = (inputDate) =>{
    return moment().diff(moment(inputDate),'days')   
}

export const getNewToday = (reportData,type) =>{
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type && getDaysDiffrence(data.created_at) < 1)
    }else {
        data = reportData.filter(data => getDaysDiffrence(data.created_at) < 1)
    }
    return data;
}


export const getPendingToday = (reportData,type) => {
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type && getDaysDiffrence(data.created_at) == 6)
    }else {
        data = reportData.filter(data => getDaysDiffrence(data.created_at) == 6)
    }
    return data;
}

export const getPendingTomorrow = (reportData, type) =>{
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type && getDaysDiffrence(data.created_at) == 5)
    }else{
        data = reportData.filter(data => getDaysDiffrence(data.created_at) == 5)
    }
    return data;
}


export const getPendingThisWeek = (reportData,type) =>{
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type && getDaysDiffrence(data.created_at) >= 1 && getDaysDiffrence(data.created_at) < 5 )
    }else {
        data = reportData.filter(data => getDaysDiffrence(data.created_at) >= 1 && getDaysDiffrence(data.created_at) < 5 )
    }
    return data;
}


export const getOverDue = (reportData,type) =>{
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type && getDaysDiffrence(data.created_at) >= 7)
    } else{
        data = reportData.filter(data => getDaysDiffrence(data.created_at) >= 7)
    }
    return data;
}


export const getTotal = (reportData,type) =>{
    let data;
    if(type){
        data = reportData.filter(data => data.grievanceType == type)
    } else {
        data = reportData;
    }
    return data;
}


